/**
 * Created by FengqiZhang on 24/3/17.
 */

import $ from 'jquery';

export let headOffset: number = 0;

export class StickyPanel {
  public static frontend(el: HTMLElement, opt: any) {
    return new this($(el), opt);
  }
  public $fill: JQuery;
  public mode: string = 'head';
  public sticky: {s: number; m: number; l: number};

  public m = 40 * 16;
  public l = 64 * 16;
  public state = null;

  public oldStyleId: number = 0;

  constructor(
    public $el: JQuery,
    public data: {
      mode: string;
      sticky: {s: number; m: number; l: number};
      scrollUp: number;
      scrollDown: number;
    },
  ) {
    this.mode = data.mode;
    this.sticky = data.sticky;
    this.oldStyleId = data.scrollUp;
    this.init();
  }

  public init() {
    if (
      (this.sticky.s > 0 && this.sticky.s < 4) ||
      (this.sticky.m > 0 && this.sticky.m < 4) ||
      (this.sticky.l > 0 && this.sticky.l < 4)
    ) {
      if (this.$el.parents('.me-block').length > 0) {
        throw new Error(
          'Unable to use sticky when block is not at top level of dom',
        );
      }
      if (this.mode === 'head' && this.$el.prev().length > 0) {
        throw new Error('Sticky Header must be first block on page');
      }
      if (this.mode === 'foot' && this.$el.next().length > 0) {
        throw new Error('Sticky Footer must be last block on page');
      }
      this.setupSticky();
    }
  }

  public setupSticky() {
    this.$fill = $('<div></div>');
    if (this.mode === 'head') {
      this.initScroll();
    }
    $(window).resize(() => {
      const w = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0,
      );
      const newState = this.l <= w ? 'l' : this.m <= w ? 'm' : 's';
      if (newState !== this.state) {
        this.changeState(newState);
      }
    });
    $(window).on('load', () => {
      const w = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0,
      );
      const newState = this.l <= w ? 'l' : this.m <= w ? 'm' : 's';
      this.changeState(newState);
    });
  }
  public getHeight() {
    const h = this.$el.height();
    if (this.mode === 'head') {
      headOffset = this.sticky[this.state] > 0 ? h : 0;
    }
    if (this.state && this.sticky[this.state] === 1) {
      return h;
    }
    return 0;
  }

  public changeState(state) {
    this.state = state;
    if (this.sticky[state] === 2) {
      if (this.mode === 'head') {
        this.$el.after(this.$fill);
      } else {
        this.$el.before(this.$fill);
      }
      // this.$el.css('position','fixed');
      // this.$el.addClass('me-fixed');
    } else {
      this.$fill.detach();
      // this.$el.css('position','');
      // this.$el.removeClass('me-fixed');
    }
    this.$fill.css('height', `${this.getHeight()}px`);
  }

  public initScroll() {
    if (
      this.data.hasOwnProperty('scrollUp') &&
      this.data.hasOwnProperty('scrollDown')
    ) {
      const scrollTop = [
        () =>
          this.updateStyle(this.$el, this.data.scrollDown, this.data.scrollUp),
      ];
      const scrollDown = [
        () =>
          this.updateStyle(this.$el, this.data.scrollUp, this.data.scrollDown),
      ];

      $('[data-scroll]').each((i, el) => {
        const $this = $(el);
        const scroll = parseInt(/\d+/.exec($this.attr('data-scroll'))[0], 10);
        const top = parseInt(/\d+/.exec($this.attr('data-top'))[0], 10);
        scrollTop.push(() => this.updateStyle($this, scroll, top));
        scrollDown.push(() => this.updateStyle($this, top, scroll));
      });

      let top = true;
      $(window).scroll((e) => {
        const pos = $(e.target).scrollTop();
        if (pos > 1 && top) {
          top = false;
          scrollDown.forEach((fn) => fn());
        } else if (pos <= 1 && !top) {
          top = true;
          scrollTop.forEach((fn) => fn());
        }
      });
      if ($(window).scrollTop() > 1) {
        top = false;
        scrollDown.forEach((fn) => fn());
      }
    }
  }

  public updateStyle($el, oldId: number, newId: number) {
    $el.removeClass(`MES${oldId}`).addClass(`MES${newId}`);
    $el.removeClass(`MEC${oldId}`).addClass(`MEC${newId}`);
    $el.find(`.MEC${oldId}`).removeClass(`MEC${oldId}`).addClass(`MEC${newId}`);
  }
}
